module.exports = __webpack_public_path__ + "img/bg-2.69ad0ada.jpg";